import { Injectable } from '@angular/core';
import { catchError, from, map, Observable, tap } from 'rxjs';
import { StoreService } from '..';
import { CountriesApiService, CountryNames } from '../../services/api/countries-api.service';

/**
 * The countries an accent can be named after, code to name in the admin's content language.
 * Loaded once at sign-in; the accent screens read them from here.
 */
@Injectable({
  providedIn: 'root',
})
export class CountryService {
  constructor(
    private readonly store: StoreService,
    private readonly countriesApiService: CountriesApiService,
  ) {}

  get countries$(): Observable<CountryNames> {
    return this.store.state$.pipe(map((state) => state.countries));
  }

  load(): Observable<CountryNames> {
    return from(this.countriesApiService.getCountries()).pipe(
      tap((countries) => {
        this.store.setState({ ...this.store.state, countries });
      }),
      catchError((error) => {
        console.error('Error loading countries:', error);
        throw error;
      }),
    );
  }

  clear(): void {
    this.store.setState({ ...this.store.state, countries: {} });
  }
}
